/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui'; // iui-utils
import { url } from 'utils/urls';



/* ++++++++++ --------------- ADD-ON CARD : STYLES --------------- ++++++++++ */
export default theme => ({
    addoncard: {
        //switch to 100%
        width: pxToEm(875),
        maxWidth: pxToEm(875),
        margin: '0 auto',
        padding: pxToEm(8),
        border: `${pxToEm(1)} solid rgb(236, 240, 247)`,
        boxShadow: `${pxToEm(0)} ${pxToEm(1)} ${pxToEm(1)} ${pxToEm(0)} rgb(237, 241, 250)`,
        '& .carddetails': {
            height: '100%',
            display: 'flex',
            alignItems: 'flex-start',
            padding: `${pxToEm(8)} ${pxToEm(16)} 0 ${pxToEm(8)}`,
            '& .cardinner': {
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                '& .titletoggle': {
                    display: 'flex',
                    justifyContent: 'space-between',
                    marginBottom: pxToEm(8),
                    '& .toggle': {
                        width: pxToEm(40),
                        height: pxToEm(20),
                        '& .ball': {
                            height: pxToEm(18),
                            width: pxToEm(18)
                        }
                    }
                },
                '& .description': {
                    marginBottom: pxToEm(28),
                    fontSize: pxToEm(14),
                    '& .descriptiontext': {
                        position: 'relative',
                        fontWeight: 'normal',
                        color: 'rgb(130, 149, 186)',
                        maxWidth: pxToEm(524),
                        height: 'auto',
                        maxHeight: pxToEm(54),
                        textOverflow: 'ellipsis',
                        paddingRight: pxToEm(5),
                        transition: 'max-height .4s',
                        textAlign: 'left',
                        '&.descriptionexpandable-true': {
                            overflow: 'hidden',
                            '&:after': {
                                content: '""',
                                textAlign: 'right',
                                position: 'absolute',
                                bottom: 0,
                                right: 0,
                                width: '25%',
                                height: '1.2em',
                                background: 'linear-gradient(to right, rgba(255, 255, 255, 0), rgba(255, 255, 255, 1) 50%)'
                            }
                        },
                        '&.descriptionexpanded-true': {
                            maxHeight: pxToEm(1000),
                            // transition: 'max-height .2s'
                        }
                    },
                    '& .cta': {
                        fontWeight: '500',
                        color: 'rgb(20, 148, 244)',
                        marginTop: pxToEm(10)
                    }
                },
                '& .innerfooter': {
                    '& .footercontrols': {
                        display: 'flex',
                        justifyContent: 'space-between',
                        '& .ctas': {
                            '& .cta': {
                                fontSize: pxToEm(14),
                                fontWeight: '500',
                                height: pxToEm(32),
                                width: 'fit-content',
                                marginRight: pxToEm(16),
                                '&:last-child': {
                                    marginRight: '0'
                                },
                                '&.name-preview': {
                                    width: pxToEm(88)
                                },
                                '& i': {
                                    fontSize: pxToEm(14)
                                }
                            }
                        },
                        '& .footernote': {
                            fontSize: pxToEm(14),
                            fontWeight: 'normal',
                            color: 'rgb(192, 201, 220)'
                        }
                    }
                }
            },
            '& img': {
                marginRight: pxToEm(24)
            },
            '& h4': {
                fontWeight: '500'
            },
        },
        '& .creationsection': {
            display: 'flex',
            justifyContent: 'center',
            backgroundColor: 'rgb(250, 251, 252)',
            transition: `all .2s linear 0s`,
            maxHeight: 0,
            height: 0,
            '&.open-true':{
                maxHeight: pxToEm(800),
                height: 'auto'
            }
        }
    }
});
